import React, { useCallback, useEffect, useState } from "react";
import { Button } from "@storybook/button";

import { Image, Loader } from "@storybook";

import "./browser-registration-modal.scss";

interface IBrowserRegistrationModal {
  onBack: () => void;
  onContinue: () => Promise<void>;
}

let isBrowserRegistrationModalCalled = false;
export const BrowserRegistrationModal: React.FC<IBrowserRegistrationModal> = ({
  onBack,
  onContinue,
}) => {
  const [loading, setLoading] = useState(false);

  const handleContinue = useCallback(async () => {
    if (isBrowserRegistrationModalCalled) {
      return;
    }
    isBrowserRegistrationModalCalled = true;
    setLoading(true);
    await onContinue().catch(() => {
      setLoading(false);
    });
  }, [onContinue]);


  useEffect(() => {
    return () => {
      setLoading(false);
      isBrowserRegistrationModalCalled = false;
    };
  }, []);

  return (
    <div className="browser-registration-modal">
      <div className="browser-registration-modal__icon">
        <Image
          url="https://storage.googleapis.com/satschel-public-assets/images/simplici-media/confirmation_page.svg"
          className="confirmation-image"
        />
        <h4 className="browser-registration-modal__title">
          Looks like this browser is not registered!
        </h4>
      </div>

      <div className="browser-registration-modal__content">
        <p className="browser-registration-modal__subtitle">
          Please continue to register this browser.
        </p>
      </div>

      <div className="browser-registration-modal__actions">
        <Button label="Back" handleClick={onBack} type="secondary" />
        <Button
          label="Continue"
          disabled={loading}
          loader={loading ? <Loader dimension={20} type="loader" /> : undefined}
          handleClick={handleContinue}
          type="primary"
        />
      </div>
    </div>
  );
};
